/**
 * What a message lets the Agent change without asking first. `manual`
 * confirms every write, `auto` confirms the ones that spend credits, run a
 * workflow or code, or change a connected account, and `accept_all`
 * confirms nothing. Stored with the message by the server.
 */
export const PERMISSION_MODES = ['manual', 'auto', 'accept_all'] as const

export type PermissionMode = (typeof PERMISSION_MODES)[number]

export const DEFAULT_PERMISSION_MODE: PermissionMode = 'auto'

export function isPermissionMode(value: unknown): value is PermissionMode {
  return typeof value === 'string' && (PERMISSION_MODES as readonly string[]).includes(value)
}
